import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";

function AuthCallbackPage() {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    // `detectSessionInUrl: true` triggers exchange on module load. We just
    // wait for the resulting auth event and navigate. `_authenticated.beforeLoad`
    // does the whitelist check.
    const { data: sub } = supabase.auth.onAuthStateChange((event, session) => {
      if (cancelled) return;
      if (event === "SIGNED_IN" && session) {
        void navigate({ to: "/" });
      }
    });
    // Safety: if no event arrives within 5s, assume the exchange failed.
    //
    // `session_failed`, NO `not_whitelisted`: aquí no sabemos nada del email —no
    // hay sesión que mirar—, así que acusar a la cuenta es sencillamente falso.
    // Este código decía `not_whitelisted` y mandó a auditar la whitelist durante
    // el cutover del 2026-08-03, cuando la causa real era que GoTrue rechazaba el
    // preflight CORS por la cabecera `apikey` y el navegador abortaba el
    // POST /token antes de emitirlo. Ver doc/setup/coolify.md §6.bis.10.
    const timeout = setTimeout(() => {
      if (cancelled) return;
      supabase.auth.getSession().then(({ data }) => {
        if (cancelled) return;
        if (data.session) {
          void navigate({ to: "/" });
        } else {
          setErrorMessage("No se pudo completar el inicio de sesión.");
          void navigate({ to: "/login", search: { error: "session_failed" } });
        }
      });
    }, 5000);
    return () => {
      cancelled = true;
      clearTimeout(timeout);
      sub.subscription.unsubscribe();
    };
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-base">
      <div className="text-center">
        <p className="text-sm text-text-secondary">
          {errorMessage ?? "Verificando acceso…"}
        </p>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/auth/callback")({
  component: AuthCallbackPage,
});
